import { get } from "lodash"
import authStore from "../stores/auth"
import moment from "moment"

export const useSpecialSubscriptionPrice = () => {
  const user = get(authStore, "state.user", "user not found")
  const isSpecialPriceActive =
    user?.effective_date_subscription_price &&
    moment().isSameOrAfter(moment(user?.effective_date_subscription_price))

  return {
    monthlySpecialSubscriptionPrice: user?.monthly_special_subscription_price,
    weeklySpecialSubscriptionPrice: user?.weekly_special_subscription_price,
    mlpMonthlySpecialSubscriptionPrice:
      user?.mlp_monthly_special_subscription_price,
    mlpWeeklySpecialSubscriptionPrice:
      user?.mlp_weekly_special_subscription_price,
    effectiveDateDubscriptionPrice: user?.effective_date_subscription_price,
    isSpecialPriceActive,
    activeSpecialMonthlyPrice:
      isSpecialPriceActive && user?.monthly_special_subscription_price
        ? user?.monthly_special_subscription_price
        : null,
    activeSpecialWeeklyPrice:
      isSpecialPriceActive && user?.weekly_special_subscription_price
        ? user?.weekly_special_subscription_price
        : null,
    activeMlpSpecialMonthlyPrice:
      isSpecialPriceActive && user?.mlp_monthly_special_subscription_price
        ? user?.mlp_monthly_special_subscription_price
        : null,
    activeMlpSpecialWeeklyPrice:
      isSpecialPriceActive && user?.mlp_weekly_special_subscription_price
        ? user?.mlp_weekly_special_subscription_price
        : null,
  }
}
